export const LOADER_DURATION_MS = 3000;
export const GOAL_DURATION_MS = 60 * 60 * 1000;
export const GOALS_STORE_STORAGE_KEY = "goals:store";
